export const TYPE_OPTIONS = [
  { value: 'none', label: 'None (unlabeled)' },
  { value: 'income', label: 'Income' },
  { value: 'expense', label: 'Expense' },
  { value: 'exclude', label: 'Excluded' },
];

export const TYPE_BADGE_STYLES = {
  income: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  expense: 'bg-red-50 text-red-700 border-red-200',
  exclude: 'bg-slate-100 text-slate-600 border-slate-200',
  none: 'bg-amber-50 text-amber-700 border-amber-200',
};

export const TYPE_LABEL = { income: 'Income', expense: 'Expense', exclude: 'Excluded', none: 'None' };
